import type { Database } from 'node-sqlite3-wasm';
import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import {
  withCodeNavCacheSqlite,
  withCodeNavCacheSqliteSync,
} from '../../../sqlite/code-nav-cache/database.js';
import { loadIndexedFileEntry } from '../build/load-indexed-file-entry.js';
import { getSymbolIndexParentContext } from '../sqlite/symbol-index-sqlite.js';

function normalizeRelPath(filePath: string): string {
  return filePath.replace(/\\/g, '/').replace(/^\/+/, '');
}

function listDirectImportTargetsWithDb(db: Database, resolved: string, relPath: string): string[] {
  const ctx = getSymbolIndexParentContext(db, resolved);
  if (ctx == null) return [];
  const entry = loadIndexedFileEntry(db, ctx, relPath);
  if (entry == null) return [];
  const paths = new Set<string>();
  for (const binding of entry.imports) {
    if (binding.sourceFilePath) paths.add(binding.sourceFilePath);
  }
  return Array.from(paths);
}

export async function listDirectImportTargetsForFileAsync(parentPath: string, filePath: string): Promise<string[]> {
  const resolved = normalizeResolvedPath(parentPath);
  const relPath = normalizeRelPath(filePath);
  if (!relPath) return [];

  return withCodeNavCacheSqlite((db) => listDirectImportTargetsWithDb(db, resolved, relPath));
}

/** @deprecated Prefer {@link listDirectImportTargetsForFileAsync}. */
export function listDirectImportTargetsForFile(parentPath: string, filePath: string): string[] {
  const resolved = normalizeResolvedPath(parentPath);
  const relPath = normalizeRelPath(filePath);
  if (!relPath) return [];

  return withCodeNavCacheSqliteSync((db) => listDirectImportTargetsWithDb(db, resolved, relPath));
}
